import {
  EstadosOrdenTrabajoEnumChoice,
  gridSizeMdLg1,
  gridSizeMdLg6,
  ModulosEnumChoice,
} from "@/shared";
import {
  useFetchMotivosRechazo,
  useFetchOrdenTrabajos,
} from "@/shared/actions/erp";
import {
  CustomAutocomplete,
  SingleIconButton,
  SingleTableBoxScene,
} from "@/shared/components/ui";
import GeneralTable from "@/shared/components/ui/GeneralTable";
import { useTableFilter, useTableServerSideFiltering } from "@/shared/hooks";
import { useTableColumnsOrdenTrabajo } from "@/shared/hooks/useTableColumnsOrdenTrabajo";
import { OrdenTrabajo } from "@/shared/interfaces";
import FilterAltOffIcon from "@mui/icons-material/FilterAltOff";
import { Grid } from "@mui/material";
import { useForm } from "react-hook-form";

export type FormMotivosFiltro = {
  motivo_rechazo_tecnico: string;
};

export default function RechazadasTecnicoPEPage() {
  //HOOK PERSONALIZADO
  const { columnsRechazoTecnicoOT } = useTableColumnsOrdenTrabajo();

  const form = useForm<FormMotivosFiltro>({});
  const watchedMotivoRechazoTecnico = form.watch("motivo_rechazo_tecnico","");
  const { errors } = form.formState;
  const {
    data: motivosCorreccionContrato,
    isLoading: isLoadingMotivosCorreccionContrato,
  } = useFetchMotivosRechazo({
    estado: true,
    modulo: ModulosEnumChoice.ORDEN_TRABAJO,
    page_size: 256,
    destinos: `${ModulosEnumChoice.ACTIVACIONES}`,
  });

  const { pagination, setPagination } = useTableFilter();

  const { pageIndex, pageSize } = pagination;

  const { filterObject, columnFilters, setColumnFilters } =
    useTableServerSideFiltering();

  const {
    data: dataOTRechazadasTecnico,
    isLoading: isLoadingOT,
    isRefetching: isRefetchingOT,
  } = useFetchOrdenTrabajos({
    enabled : true,
    params:{
      page: pageIndex + 1,
      page_size: pageSize,
      estado_orden_trabajo: EstadosOrdenTrabajoEnumChoice.PRE_RECHAZADO,
      destinos_rechazo: `${ModulosEnumChoice.ACTIVACIONES}`,
      order_by: "fecha_modificacion",
      motivo_rechazo: watchedMotivoRechazoTecnico,
      ...filterObject,
    }
  })

  return (
    <SingleTableBoxScene
      title={"Rechazadas por Técnico"}
      visibleReport={true}
    >
      <Grid container spacing={2}>
        <Grid item xs={12} sx={{ display: "flex" }}>
          <CustomAutocomplete
            label="Motivo Rechazo"
            name="motivo_rechazo_tecnico"
            control={form.control}
            defaultValue={form.getValues().motivo_rechazo_tecnico || ""}
            error={errors.motivo_rechazo_tecnico}
            helperText={errors.motivo_rechazo_tecnico?.message}
            options={motivosCorreccionContrato?.data?.data || []}
            isLoadingData={isLoadingMotivosCorreccionContrato}
            valueKey="nombre"
            actualValueKey="codigo"
            optionLabelForEdit={form.getValues().motivo_rechazo_tecnico}
            size={gridSizeMdLg6}
          />
          <SingleIconButton
            size={gridSizeMdLg1}
            startIcon={<FilterAltOffIcon />}
            onClick={() => {
              form.setValue("motivo_rechazo_tecnico", "");
            }}
          />
        </Grid>
        <Grid item xs={12}>
          <GeneralTable<OrdenTrabajo>
            columns={columnsRechazoTecnicoOT}
            data={dataOTRechazadasTecnico?.data.data || []}
            isLoading={isLoadingOT}
            isRefetching={isRefetchingOT}
            enableGlobalFilter={false}
            pagination={pagination}
            onPaging={setPagination}
            rowCount={dataOTRechazadasTecnico?.data?.count}
            actionsColumnSize={120}
            canDelete={false}
            ///* filters - server side
            enableManualFiltering={true}
            columnFilters={columnFilters}
            onColumnFiltersChange={setColumnFilters}
            enableSorting={false}
            enableEditing={false}
          />
        </Grid>
      </Grid>
    </SingleTableBoxScene>
  );
}
